import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { UserRole } from '../redux/authSlice';
import './ProtectedRoute.css';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: UserRole;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { user, isAuthenticated, isRestoring, isVerifying } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  // Show loading while restoring or verifying auth state
  if (isRestoring || isVerifying) {
    return (
      <div className="loading-container">
        <div className="loading-content">
          <div className="loading-icon">⏳</div>
          <p className="loading-text">Loading...</p>
        </div>
      </div>
    );
  }

  // Check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Check if role is required and user has the correct role
  if (requiredRole && user?.role !== requiredRole) {
    // Redirect to appropriate dashboard based on user's actual role
    if (user?.role === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    } else {
      return <Navigate to="/dashboard/home" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
